export const validateEmail = (email) => {
  if (!email) return 'Email is required';

  // Basic email validation without ReDoS vulnerability
  const parts = email.split('@');
  if (parts.length !== 2) {
    return 'Invalid email format';
  }

  const [localPart, domain] = parts;

  // Validate local part (before @)
  if (!localPart || localPart.length > 64) {
    return 'Invalid email format';
  }

  // Validate domain (after @)
  if (!domain || domain.length > 255) {
    return 'Invalid email format';
  }

  // Check for domain extension
  const domainParts = domain.split('.');
  if (domainParts.length < 2) {
    return 'Invalid email format';
  }

  // Validate domain extension
  const extension = domainParts[domainParts.length - 1];
  if (!extension || extension.length < 2) {
    return 'Invalid email format';
  }

  return null;
};

export const validatePhone = (phone) => {
  // Allows formats: (123) 456-7890, 123-456-7890, 1234567890
  const phoneRegex = /^\(?(\d{3})\)?[-. ]?(\d{3})[-. ]?(\d{4})$/;
  if (!phone) return 'Phone number is required';
  if (!phoneRegex.test(phone)) return 'Invalid phone format (e.g., 123-456-7890)';
  return null;
};

// Format phone number as user types
export const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  if (phoneNumber.length < 4) return phoneNumber;
  if (phoneNumber.length < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
